import * as Sentry from '@sentry/angular';
import {
  APP_INITIALIZER,
  ApplicationConfig,
  provideZoneChangeDetection,
  ErrorHandler,
} from '@angular/core';
import { provideRouter, Router } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  _,
  ApiConfiguration,
  BaseService,
  ConfigurationService,
  MATERIAL_FLAG,
  MenuItem,
  NoMenuItem,
} from '@DataFriends-Group/ngx-core';
import { environment } from '../environments/environment';
import {
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter,
  provideMomentDateAdapter,
} from '@angular/material-moment-adapter';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { noop } from 'rxjs';
import 'moment/locale/cs.js';

function initializeApp(base: BaseService, config: ConfigurationService) {
  return () => {
    config.backend = new ApiConfiguration(
      environment.api.port ?? location.port,
      environment.api.hostname ?? location.hostname,
      environment.api.protocol ?? location.protocol,
    );

    console.log('BE address set to', config.backend);
    base.menu = [
      new NoMenuItem('app.router.access-denied', 'not-authorized'),
      new NoMenuItem('app.router.page-not-found', 'not-found'),
      new NoMenuItem('app.router.settings-page', 'settings'),
      new MenuItem('app.router.projects', 'gavel', 'projects'),
      new MenuItem('app.router.documents', 'file', 'documents'),
      new MenuItem('app.router.document-templates', 'file-broken', 'document-templates'),
      new MenuItem('app.router.companies', 'building-skyscraper', 'companies'),
      new MenuItem('app.router.contacts', 'affiliate', 'contacts'),
      new MenuItem('app.router.audit-trail', 'report-search', 'audit-trail'),
      new MenuItem('app.router.admin', 'tool', 'admin', [
        new MenuItem('app.router.users', 'users', 'admin/user'),
        new MenuItem('app.router.roles', 'users-group', 'admin/role'),
        new MenuItem('app.router.enumerators', 'list', 'admin/enum', _, _, _, true, false),
        new MenuItem('app.router.translations', 'language', 'admin/translation'),
      ]),
    ];
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideMomentDateAdapter(),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      multi: true,
      deps: [BaseService, ConfigurationService],
    },
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: DfSecretInterceptor,
    //   multi: true,
    // },
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'cs-CZ',
    },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: MAT_MOMENT_DATE_FORMATS,
    },
    {
      provide: MATERIAL_FLAG,
      useValue: true,
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {
        noop();
      },
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
};
